import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { CommonBindingDataService } from '../../services/common-binding-data.service';
import { MiGrid2Component } from 'app/modules/shared/components/mi-grid-2/mi-grid-2.component';
import { formatDateCell } from '../../../shared/utility-functions/grid';
import { GeneralLogScreenFilterModel } from '../../save-filter-models/general-logs-screen-filter-model';
import { UserCommonService } from '../../services/user-common.service';
import { AppSettings } from '../../app.settings';
import { GeneralLogScreenFiltersDataModel } from '../../save-filter-models/general-log-screen-filters-data-model';

@Component({
  selector: 'app-log-deails',
  templateUrl: './log-deails.component.html',
})
export class LogDeailsComponent implements OnInit {
  uniqId = AppSettings.UNIQID.SHARED_LOG_DEAILS_5200;

  id: any;
  fromDate: Date = null;
  toDate: Date = null;
  params: any = '';
  dateFormat;
  columns: any = [];
  url = '';
  tempUrl = '';
  breadCrumbArray: any;
  fromType;
  screenCode;

  @ViewChild(MiGrid2Component) gridRef2: MiGrid2Component;
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private commonBindingDataService: CommonBindingDataService,
    private userCommonService: UserCommonService,

  ) { }

  ngOnInit() {
    this.fromType = this.route.snapshot.queryParams['fromType'];
    if (this.fromType === 'driver') {
      this.screenCode = AppSettings.FILTER_SCREEN_CODE.DRIVER_LOGS_FROM_TO_DATE_SCREEN;
    }
    if (this.fromType === 'passenger') {
      this.screenCode = AppSettings.FILTER_SCREEN_CODE.PASSENGER_LOGS_FROM_TO_DATE_SCREEN;
    }
    if (this.fromType === 'vehicle') {
      this.screenCode = AppSettings.FILTER_SCREEN_CODE.VEHICLE_LOGS_FROM_TO_DATE_SCREEN;
    }
    this.id = this.route.snapshot.queryParams['id'];
    this.createBreadCrumb();
    this.dateFormat = this.commonBindingDataService.getDateFormat();
    this.url = '/secure/auditlogs/grid/data/' + this.id;
    this.tempUrl = '/secure/auditlogs/grid/data/' + this.id;

    this.columns.push({
      field: 'createdAt', header: this.commonBindingDataService.getLabel('label_date'),
      sort: true, resize: true, width: 150, cellRenderer: (i) => (formatDateCell(parseInt(i, 10)))
    });
    this.columns.push({
      field: 'action', header: this.commonBindingDataService.getLabel('label_action'),
      sort: true, resize: true, width: 130
    });
    this.columns.push({
      field: 'dataBeforeAction', header: this.commonBindingDataService.getLabel('label_data_before_action'),
      sort: false, resize: true, cellRendererHtml: (i) => (this.colDataBeforeActionDetails(i))
    });
    this.columns.push({
      field: 'dataAfterAction', header: this.commonBindingDataService.getLabel('label_data_after_action'),
      sort: false, resize: true, cellRendererHtml: (i) => (this.colDataAfterActionDetails(i))
    });

    this.initializeUrl();
  }

  initializeUrl() {
    const filterData: GeneralLogScreenFilterModel = this.userCommonService.getSavedFilters(this.screenCode);
    if (filterData) {
      const fDate = filterData.filterData.fromDate !== '' ? +filterData.filterData.fromDate : '';
      const tDate = filterData.filterData.toDate !== '' ? +filterData.filterData.toDate : '';
      this.fromDate = fDate !== '' ? new Date(+filterData.filterData.fromDate) : null;
      this.toDate = fDate !== '' ? new Date(+filterData.filterData.toDate) : null;

      if (this.fromDate && this.toDate) {
        this.params += ('?fromDate=' + fDate + '&toDate='
          + this.commonBindingDataService.addLapseTimeInEndDate(tDate));
        this.url = this.tempUrl + this.params;
      }
    } else {
      this.url = this.tempUrl;
    }
  }

  colDataBeforeActionDetails(params) {
    let lblActivate = '';
    if (params.dataBeforeAction) {
      lblActivate = `<div class="hand-pointer" title='${params.dataBeforeAction}'> ${params.dataBeforeAction} </div>`;
    }
    const eDiv = document.createElement('div');
    eDiv.setAttribute('class', 'grid-comman-col');
    eDiv.innerHTML = lblActivate;
    return eDiv;
  }

  colDataAfterActionDetails(params) {
    let lblActivate = '';
    if (params.dataAfterAction) {
      lblActivate = `<div class="hand-pointer" title='${params.dataAfterAction}'> ${params.dataAfterAction} </div>`;
    }
    const eDiv = document.createElement('div');
    eDiv.setAttribute('class', 'grid-comman-col');
    eDiv.innerHTML = lblActivate;
    return eDiv;
  }

  changeFilter(event?: any) {
    //
    this.params = '';
    if (this.fromDate !== undefined && this.fromDate !== null && this.toDate !== undefined || this.toDate !== null) {
      this.params += ('?fromDate=' + this.fromDate.getTime() + '&toDate='
        + this.commonBindingDataService.addLapseTimeInEndDate(this.toDate.getTime()) + '&');
    }
    this.params = this.params.slice(0, -1);
    this.reloadGrid();
    this.updateSaveFilter();
  }

  resetFilters(event?: any) {
    this.fromDate = null;
    this.toDate = null;
    this.changeFilter();
    this.updateSaveFilter();
  }

  updateSaveFilter() {
    const saveFilterModel = new GeneralLogScreenFilterModel({
      screenCode: this.screenCode,
      filterData: new GeneralLogScreenFiltersDataModel({
        fromDate: this.fromDate ? `${this.fromDate.getTime()}` : '',
        toDate: this.toDate ? `${this.toDate.getTime()}` : '',
      })
    });

    this.userCommonService.updateSavedFilter(saveFilterModel).subscribe(result => {
      this.userCommonService.updateFilterDataToLocal(result);
    }, (error) => {
    });
  }

  reloadGrid() {
    // this.gridRef.changeDatasource(this.url + this.params, this.gridColumn);
    this.gridRef2.updateUrl(this.tempUrl + this.params);

  }

  createBreadCrumb() {
    switch (this.fromType) {
      case 'driver':
        this.breadCrumbArray = [
          { 'label': this.commonBindingDataService.getLabel('label_all_drivers'), 'route': 'drivers', },
          { 'label': this.commonBindingDataService.getLabel('label_activity_logs'), 'route': '', }
        ];
        break;
      case 'passenger':
        this.breadCrumbArray = [
          { 'label': this.commonBindingDataService.getLabel('label_all_passengers'), 'route': 'passengers', },
          { 'label': this.commonBindingDataService.getLabel('label_activity_logs'), 'route': '', }
        ];
        break;
      case 'vehicle':
        this.breadCrumbArray = [
          { 'label': this.commonBindingDataService.getLabel('lbl_all_vehicles'), 'route': 'vehicles', },
          { 'label': this.commonBindingDataService.getLabel('label_activity_logs'), 'route': '', }
        ];
        break;
      case 'userManagement':
        this.breadCrumbArray = [
          { 'label': this.commonBindingDataService.getLabel('label_users'), 'route': 'user-management/manage-users', },
          { 'label': this.commonBindingDataService.getLabel('label_activity_logs'), 'route': '', }
        ];
        break;
      default:
        this.breadCrumbArray = [
          { 'label': this.commonBindingDataService.getLabel('label_activity_logs'), 'route': '', }
        ]
    }

  }

  backNavigate() {
    switch (this.fromType) {
      case 'driver':
        this.router.navigate(['/drivers']);
        break;
      case 'passenger':
        this.router.navigate(['/passengers']);
        break;
      case 'vehicle':
        this.router.navigate(['/vehicles']);
        break;
      case 'userManagement':
        this.router.navigate(['user-management/manage-users']);
        break;
    }
  }

}
